import { create } from 'zustand'
import { spaceTheme } from '../themes/space'
import { siteConfig } from '../config/siteConfig'

type ThemeName = 'space' | 'modern' | 'aurora' | 'custom'

interface ThemeStore {
  currentTheme: ThemeName
  setTheme: (theme: ThemeName) => void
  getThemeStyles: () => typeof spaceTheme
}

export const useTheme = create<ThemeStore>((set, get) => ({
  currentTheme: siteConfig.theme.name as ThemeName,
  setTheme: (theme) => set({ currentTheme: theme }),
  getThemeStyles: () => {
    const { currentTheme } = get()
    switch (currentTheme) {
      case 'space':
        return spaceTheme
      default:
        return spaceTheme
    }
  }
}))
